import type { FC, PropsWithChildren } from 'react'
import { useMemo } from 'react'
import styled from '@emotion/styled'
import Link from 'next/link'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronLeftIcon } from '@segment/matcha/components/Icons/Common'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

interface BackToProps {
  categorySlug: string
  categoryName: string
}
const BackTo: FC<PropsWithChildren<BackToProps>> = ({ categorySlug, categoryName }) => {
  const pageConfig = usePageConfig()
  const buttonUrl = getAbsoluteUrl(`/data-hub/${categorySlug}/`, pageConfig)
  const buttonText = useMemo(() => `Back to ${categoryName}`, [categoryName])

  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <Link href={buttonUrl}>
          <ButtonText tag="span" size="small" iconStart={ChevronLeftIcon}>
            {buttonText}
          </ButtonText>
        </Link>
      </Section.Contents>
    </StyledSectionBase>
  )
}

export default BackTo

const StyledSectionBase = styled(SectionBase)`
  margin-top: -56px;
`
